import { ref, computed } from "vue";
import { defineStore } from "pinia";
import { useCoins } from "@/composables/useCoins";

export const useExchangeStore = defineStore("exchange", () => {
  const form = ref({
    from: {
      coin: null,
      amount: null,
    },
    to: {
      coin: null,
      amount: null,
    },
  });

  const isAvailable = ref(false);
  const setAvailable = (value) => {
    isAvailable.value = value;
  };

  const DEFAULT_FROM_COIN = "btc";
  const DEFAULT_TO_COIN = "usdt";
  const setDefaults = () => {
    setFromCoin(DEFAULT_FROM_COIN);
    setToCoin(DEFAULT_TO_COIN);
  };

  const setFromCoin = (coin) => {
    const coins = useCoins().coins.value;
    const coinObj = coins.find((a) => a.config.id === coin);
    if (coinObj) {
      form.value.from.coin = coinObj;
    }
  };

  const setToCoin = (coin) => {
    const coins = useCoins().coins.value;
    const coinObj = coins.find((a) => a.config.id === coin);
    if (coinObj) {
      form.value.to.coin = coinObj;
    }
  };

  const swapCoins = () => {
    const from = form.value.from;
    form.value.from = form.value.to;
    form.value.to = from;
    form.value.from.amount = null;
    form.value.to.amount = null;
  };

  const calculate = (type) => {
    const from = form.value.from;
    const to = form.value.to;
    if (type === "from") {
      if (from.amount === 0 || from.amount === null || from.amount === "") {
        form.value.to.amount = null;
        return;
      }
    }
    if (type === "to") {
      if (to.amount === 0 || to.amount === null || to.amount === "") {
        form.value.from.amount = null;
        return;
      }
    }
    if (limits.value) {
      // const to = form.value.to
      const pair = limits.value.pair;
      let price = limits.value.rate_buy;
      const pairArr = pair.id.split("-");
      if (pairArr[0] === from.coin.config.id) {
        price = limits.value.rate_sell;
        if (type === "from") {
          form.value.to.amount = Number(
            (form.value.from.amount * price).toFixed(8),
          );
        }
        if (type === "to") {
          form.value.from.amount = Number(
            (form.value.to.amount / price).toFixed(8),
          );
        }
      } else {
        if (type === "from") {
          form.value.to.amount = Number(
            (form.value.from.amount / price).toFixed(8),
          );
        }
        if (type === "to") {
          form.value.from.amount = Number(
            (form.value.to.amount * price).toFixed(8),
          );
        }
      }
    }
  };

  const pairs = ref([]);

  const availablePairs = computed(() => {
    if (form.value.from.coin) {
      const coins = useCoins().coins.value;
      const arr = pairs.value.filter((a) => {
        return a.id.indexOf(form.value.from.coin.config.id) !== -1;
      });
      const cleanArr = arr.map((a) => {
        return a.id
          .replace("-", "")
          .replace(form.value.from.coin.config.id, "");
      });
      const availableCoins = coins.filter((a) =>
        cleanArr.find((b) => b === a.config.id),
      );
      return {
        dirs: arr,
        coins: availableCoins,
      };
    }
    return {
      dirs: [],
      coins: [],
    };
  });

  const setPairs = (arr) => {
    pairs.value = arr;
  };

  const validatePairs = () => {
    if (!form.value.to.coin.config) {
      setToCoin(DEFAULT_TO_COIN);
    }
    const isFormToAvailable = availablePairs.value.coins.find(
      (a) => a.config.id === form.value.to.coin.config.id,
    );
    // Нет пар для монеты — оставляем текущую, иначе в form.to.coin попадёт undefined
    if (!isFormToAvailable && availablePairs.value.coins.length) {
      form.value.to.coin = availablePairs.value.coins[0];
    }
  };

  const limits = ref(null);

  const setLimits = (pair, data) => {
    limits.value = {
      ...data,
      pair,
    };
    calculate("from");
  };

  const setCalculated = (direction, data) => {
    if (direction === "sell") {
      limits.value.rate_sell = data.rate;
      form.value.from.amount = data.amount_base;
      form.value.to.amount = data.amount_quote;
    } else {
      limits.value.rate_buy = data.rate;
      form.value.from.amount = data.amount_quote;
      form.value.to.amount = data.amount_base;
    }
  };

  const formClear = () => {
    // form.value = JSON.parse(JSON.stringify(formDefaults))
    // setDefaults()
    form.value.from.amount = 0;
    form.value.to.amount = 0;
  };

  return {
    form,
    setFromCoin,
    setToCoin,
    swapCoins,
    calculate,
    formClear,
    setDefaults,
    pairs,
    availablePairs,
    setPairs,
    validatePairs,
    limits,
    setLimits,
    setCalculated,
    isAvailable,
    setAvailable,
    DEFAULT_FROM_COIN,
    DEFAULT_TO_COIN,
  };
});
